// ===================================================================
// 🔔 CONTEXTO DE NOTIFICAÇÕES DO SISTEMA INGRESSAIF
// ===================================================================

import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = React.memo(({ children }) => {
  const [notifications, setNotifications] = useState([]);

  const addNotification = useCallback((title, message, type = 'info') => {
    const id = Date.now();
    const notification = {
      id,
      title,
      message,
      type,
      timestamp: new Date(),
      read: false
    };
    
    setNotifications(prev => [notification, ...prev]);
  }, []);

  const markAsRead = useCallback((id) => {
    setNotifications(prev => 
      prev.map(notif => 
        notif.id === id ? { ...notif, read: true } : notif
      )
    );
  }, []);

  const clearAll = useCallback(() => {
    setNotifications([]);
  }, []);

  const removeNotification = useCallback((id) => {
    setNotifications(prev => prev.filter(notif => notif.id !== id));
  }, []);

  const contextValue = useMemo(() => ({
    notifications,
    addNotification,
    markAsRead,
    clearAll,
    removeNotification
  }), [notifications, addNotification, markAsRead, clearAll, removeNotification]);

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  );
});

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications deve ser usado dentro de um NotificationProvider');
  }
  return context;
}; 